import { Text } from '@reckon-web/text';
import { forwardRefWithAs } from '@reckon-web/utils';

type MessageProps = {
  /** The ID of the element. */
  id?: string;
};

export const FieldMessage = forwardRefWithAs<'div', MessageProps>(
  (props, ref) => {
    return <Text color="critical" size="small" ref={ref} {...props} />;
  }
);
